import { UnwrapHelper } from '../UnwrapHelper';
export class UnwrapNumberHelper extends UnwrapHelper {
}

//# sourceMappingURL=UnwrapNumberHelper.js.map
